export default theme => ({
  fileEditor: {
    height: "calc(100vh - 400px)",
    minHeight: "300px",
    overflow: "hidden",
    "& > div": {
      height: "100%",
      minHeight: "300px",
    },
    "& div.jsoneditor": {
      border: `thin solid ${theme.palette.primary.main}`,
    },
    "& div.jsoneditor-outer": {
      height: "100%",
      overflow: "auto",
    },
    "& #jsonInputId-container": {
      height: "100% !important",
      overflow: "auto !important",
    },
  },
});
